import "./MenuButton.css"
import React from "react"

const MenuButton = ({label}) => <div className="MenuButton-button">{label.toUpperCase()}</div>

export default MenuButton